import { Star } from "lucide-react";
import { REVIEWS } from "@/data/content";
import { Reveal } from "./Reveal";

export const Reviews = () => (
  <section data-testid="reviews-wall-section" className="pb-24 lg:pb-32">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
      <h2 className="font-display text-4xl sm:text-6xl leading-[0.95] mb-10">What people are saying</h2>
      <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={(i % 3) * 0.06} data-testid={`review-card-${i}`}
            className="break-inside-avoid mb-4 rounded-[24px] bg-white border border-[#1B1530]/10 p-7 hover:-translate-y-1 transition-transform duration-300">
            <div className="flex gap-0.5 text-[#FFB21A]">{[0, 1, 2, 3, 4].map((s) => <Star key={s} className="h-4 w-4 fill-current" />)}</div>
            <p className="mt-4 text-[17px] leading-relaxed">"{r.text}"</p>
            <p className="mt-5 text-sm font-bold text-[#4A4560]">{r.name}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
